import { HttpClient } from '@angular/common/http';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Router } from '@angular/router';
import { PaymentService } from '../payment.service';
import { SidebarService } from '@ibe/services/ui';
import { Payment } from '@ibe/models';
import { Subscription, Observable } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import * as fromStore from '@ibe/store/index';

import { BrowserInfo } from '@ibe.models/payment_creditcard.model';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { INDRAPaymentService } from '@ibe.services/payment.indra.service';
import { INDRABookingPaymentService } from '@ibe.services/booking-payment.indra.service';
import { INDRAFlightPriceService } from '@ibe.services/flight-price.indra.service';

import { 
	SESSION_VAR_KEY_PAYMENT_SESSION_ID, 
	PAYMENT_METHOD_POLI, 
	PAYMENT_RESULT,
	PAYMENT_METHOD_PARAM_MERCHANT_ACCOUNT_IBE,
	SESSION_VAR_KEY_LANGUAGE,
	DEFAULT_LANGUAGE,
	SPECIAL_CASE_MARKET_LANGUAGE_MAP,
	SESSION_VAR_KEY_MARKET,
	DEFAULT_MARKET
} from '@ibe.config';
import { INDRAIbeAdminConfigService } from '@ibe.services/ibeadmin-config.service';

@Component({
	selector: 'app-payment-method-poli',
	templateUrl: './payment-method-poli.indra.component.html',
	styleUrls: ['./payment-method-poli.component.scss']
})
export class INDRAPaymentMethodPoliComponent implements OnInit, OnDestroy {
	
	@Input() displayCovidTermsAndCondition: boolean = false;
	
	pnr: any;
	lastname: any;
	isBookingPaymentPage: boolean = false;
	merchantAccount;

	isAlive: boolean = true;
	allSubs: Subscription[] = [];

  formIsValid$ = this.paymentInfoService.formIsValid;

	constructor(
		protected _http: HttpClient,
		private store: Store<fromStore.State>,
		private router: Router,
		private paymentInfoService: PaymentService,
		private sidebarService: SidebarService,
		private storage: INDRAStorageService,
		private indraPaymentService: INDRAPaymentService,
		private paymentMethodService: INDRABookingPaymentService,
		private flightPriceService: INDRAFlightPriceService,
		private ibeAdminConfigService: INDRAIbeAdminConfigService,
	) {
		this.pnr = this.storage.get('bookingPnr');
		this.lastname = this.storage.get('lastname');
		this.merchantAccount = this.paymentMethodService.INDRA_getPaymentMethodParamValues(PAYMENT_METHOD_PARAM_MERCHANT_ACCOUNT_IBE, PAYMENT_METHOD_POLI);
	}

	ngOnInit() {
		if (this.router.url.includes('/booking/payment')) {
			this.isBookingPaymentPage = true;
		}

		const payFormSub = this.paymentInfoService.paymentFormSubmitted.subscribe(value => {
			if (value && value == this.paymentInfoService.paymentMethods.poli.id) {
				this.INDRA_submitPayment();
			}
		});
		
		this.allSubs.push(payFormSub);
	}
	
	ngOnDestroy() {
		this.isAlive = false;
		for (const sub of this.allSubs) {
			if (sub) sub.unsubscribe();
		}
	}

	INDRA_acceptTermsAndConditionsChange(event) {
		if (event.target.checked) {
			this.paymentInfoService.setFormIsValid(true);
		} else {
			this.paymentInfoService.setPaymentInfo(null);
			this.paymentInfoService.setFormIsValid(false);
		}
	}

	INDRA_submitPayment() {

		const paymentBaseURL = this.isBookingPaymentPage ? 'booking/payment' : '/time-to-think/payment';
		const operationID = this.paymentInfoService.getPaymentOperationID();

		const totalFlightPrice = this.paymentInfoService.getTotalFlightPrice();
		const cashPrice = this.flightPriceService.INDRA_convertToCorrectDecimalPlace(totalFlightPrice.cash.toString());
		const currency = totalFlightPrice.currency;
		
		let request = {
			// browserInfo: new BrowserInfo(),
			deviceChannel: 'browser',
			// deviceFingerPrintId: sessionStorage.getItem(SESSION_VAR_KEY_PAYMENT_SESSION_ID),
			merchantAccount: this.merchantAccount,
			sessionId: this.storage.get('token'),
			urlNavegationOk: `my-bookings/view/${this.pnr}/${this.lastname}?issue=`,
			urlNavegationKo: `${paymentBaseURL}/redirect/${this.pnr}?issue=`,
			currency: currency,
			amount: +(cashPrice),
			pnr:  this.pnr,
			idOperation: null,
			paymentMethodCode: PAYMENT_METHOD_POLI,
			paymentMethod: 'poli',
			ipAddress: this.paymentInfoService.getClientIPAddress()
		};

		if (totalFlightPrice && totalFlightPrice.miles) {
			request['points'] = totalFlightPrice.miles;
		}

		const userData = this.storage.get('userData');
		if (userData) {
			request['flyTapId'] = userData.airlineID;
		}
		
		const paymentSub = this.indraPaymentService.INDRA_paymentRedirectShopper(request).subscribe((res) => {
			if (res && res.data && res.data.idOperation) {
				this.paymentInfoService.setPaymentOperationID(res.data.idOperation);
				this.storage.set('idOperation', res.data.idOperation);
			}
			
			if (res && (res.status === '200' || res.status === '211') && 
				res.data && res.data.paymentResultAdyen && res.data.paymentResultAdyen.resultCode === 'RedirectShopper') {
					
				// create paymentInfo object and save it to session storage
				const paymentInfo: Payment = {
					name: '',
					time: new Date(),
					status: 'pending',
					method: 'poli',
				};
				this.paymentInfoService.setPaymentInfo(paymentInfo);
				this.storage.set('payment_info', paymentInfo);
				
				return window.open(res.data.paymentResultAdyen.redirect.url, '_self');

			} else if (res.status === '400' && res.errors && res.errors.length && res.errors.some(err => err.code === '34' &&
				err.desc === "Error PNR paid IBE")) {
				this.paymentInfoService.setGenericPaymentResult(PAYMENT_RESULT.PAID_ERROR);

			} else {
				this.paymentInfoService.setGenericPaymentResult(PAYMENT_RESULT.ERROR);
			}
		}, 
		(error) => {
			this.paymentInfoService.setGenericPaymentResult(PAYMENT_RESULT.TECHNICAL_ERROR);
		});
		
		this.allSubs.push(paymentSub);
	}
	
	INDRA_handleBookingTicketConditions() {
		this.sidebarService.openSidebar(['booking-ticket-conditions']);
	}

	INDRA_gotoURL(key) {
		const languageCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ? sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE).toLowerCase() : DEFAULT_LANGUAGE;
		const languageMap = SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] ? SPECIAL_CASE_MARKET_LANGUAGE_MAP[languageCode] : languageCode;
		const marketCode = sessionStorage.getItem(SESSION_VAR_KEY_LANGUAGE) ? sessionStorage.getItem(SESSION_VAR_KEY_MARKET).toLowerCase() : DEFAULT_MARKET;
		const urlIbeAdmin = this.ibeAdminConfigService.getConfigurationValue(key);
		const urlNavigate = urlIbeAdmin.replace('${lang}', `${languageMap}`).replace('${market}', `${marketCode}`);
		return window.open(urlNavigate);
	}
}
